import { CommonModule } from "@angular/common";
import { UiModule } from "@topyourthree/ui";
import * as i0 from "@angular/core";
export class SectionSearchHeaderModule {
}
SectionSearchHeaderModule.ɵfac = function SectionSearchHeaderModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SectionSearchHeaderModule)(); };
SectionSearchHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SectionSearchHeaderModule });
SectionSearchHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, UiModule] });
